import React, { useEffect, useRef, useState } from "react";

import { Route, Routes } from "react-router-dom";
import { BackToTop } from "../../common/component/back-to-top/back-to-top";
import { Dialog } from "../../common/component/dialog/dialog";
import { Help } from "./help/help";
import { Loader } from "../../common/component/loader/loader";
import { PalletPickupFormDialog } from "./pallet-pickup/pallet-pickup-form-dialog";
import { context } from "../../context/context";
import { Permission } from "../../context/permission";
import { UserNotificationCenter } from "../../common/component/notifications/notification-center/user-notification-center";
import { Message } from "../../common/component/notifications/message";
import { PreparationLayout } from "../navigation/preparation-layout";
import ControlPanelRouter from "./control-panel/router";
import { freshdeskWidgetService } from "../services/freshdesk-widget";
import { useUserSessionContext } from "../../common/context/application-context/user-session-context-provider";

import "../../style/style.scss";
import "./style.scss";

export const ClickAndShipApp  = () => {
    const { locale } = useUserSessionContext();
    const [shouldOpenPalletPickupFormDialog, setShouldOpenPalletPickupFormDialog]
        = useState(context.hasPermission(Permission.FeaturePalletPickUpForm));
    const [isScrolled, setIsScrolled] = useState(false);
    const isScrolledRef = useRef(isScrolled);

    useEffect(() => {
        freshdeskWidgetService.initializeWidget(locale);
    }, [locale]);

    useEffect(() => {
        isScrolledRef.current = isScrolled;
    }, [isScrolled]);

    useEffect(() => {
        const handleScroll = () => {
            if (!isScrolledRef.current && window.pageYOffset > 0) {
                setIsScrolled(true);
            } else if (isScrolledRef.current && window.pageYOffset === 0) {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const onPalletPickupFormDialogClose = () => {
        setShouldOpenPalletPickupFormDialog(false);
    };

    return <div data-component="app-root">
        <div data-component="page">
            <div className="content">
                <Routes>
                    <Route path="help" element={<Help />}/>
                    <Route path="settings/*" element={<ControlPanelRouter />}/>
                    <Route path="/*" element={<PreparationLayout />}/>
                </Routes>
            </div>
        </div>
        <Dialog/>
        {shouldOpenPalletPickupFormDialog && <PalletPickupFormDialog openOnStartup={true} onDialogClose={onPalletPickupFormDialogClose}/>}
        <Loader isBackground={false}/>
        <UserNotificationCenter/>
        <Message/>
        {isScrolled && <BackToTop />}
    </div>;
};
